import { payloadAction, PayloadActionFactory } from '@lovejunk/core'

import { SAVE_UTM, SaveUtm, Utm } from './types'

export const saveUtmParams: PayloadActionFactory<SaveUtm, Partial<Utm>> = payloadAction(SAVE_UTM)
